import React from 'react';
import PrinterForm from './PrinterForm'
import { Paper, Grid, withStyles } from '@material-ui/core';
import History from "../../../History";
import * as Yup from "yup";
import { snackActions } from '../../sc-utilities/SnackBar';
import * as actions from './store/printerActions';
import { BackButton, hasPermission } from '../../sc-utilities';
import { connect } from "react-redux";
import { isValidPrinterAddress } from './printer.utility';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    }
});

const types = [
    { value: 'zebra', displayValue: 'Zebra' },
    { value: 'godex', displayValue: 'Godex' },
    { value: 'brother', displayValue: 'Brother' },
    { value: 'dymo', displayValue: 'Dymo' }
];

const PrinterCreate = props => {
    const { classes, activeCustomer, onCreatePrinter, translations, permissions, creating } = props;

    const handleSubmit = formData => {
        const {MobileLabelTemplateID, WorkLabelTemplateID, ...restData} = formData;
        if (restData.ConnectionType === 'network' && !isValidPrinterAddress(formData)) {
            snackActions.snackBarComponent(translations['printer_address'] || 'Printer address is invalid.', 'warning');
            return;
        }
        let result = onCreatePrinter({ ...restData, ActiveCustomerID: activeCustomer, LabelTemplates: [ WorkLabelTemplateID, MobileLabelTemplateID ] });
        if (result) {
            History.goBack();
        }
    }

    let initialValues = {
        Name: "",
        PrinterType: types[0].value || '',
        ConnectionType: 'network',
        URI: '',
        DirectPrinter: false,
        WorkLabelTemplateID: "",
        MobileLabelTemplateID: ""
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            PrinterType: Yup.string().required("Required"),
            ConnectionType: Yup.string().required("Required"),
            URI: Yup.string().when("ConnectionType", {
                is: val => val === 'network',
                then: Yup.string().required('Required')
            }),
            DirectPrinter: Yup.bool().required("Required"),
            WorkLabelTemplateID: Yup.string(),
            MobileLabelTemplateID: Yup.string()
        },
        FormTitle: translations["create_printer"] || "Create printer",
        ButtonSubmit: hasPermission(permissions, "printer_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };

    return (
        <Paper className={classes.root}>
            <Grid container spacing={10}>
                <Grid item xs={12}>
                    {BackButton(translations)}
                    <PrinterForm
                        formSettings={formSettings}
                        initialValues={initialValues}
                        handleSubmit={handleSubmit}
                        types={types}
                        translations={translations}
                        loading={creating}
                        activeCustomer={activeCustomer}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        creating: state.setting.printers.editing
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreatePrinter: printer => dispatch(actions.createPrinter(printer))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(PrinterCreate));
